module.exports = __webpack_public_path__ + "static/img/status_bar_left.0d70064.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/status_bar_left.png
// module id = 1264
// module chunks = 0